/* eslint-disable i18next/no-literal-string */
import { useCallback, useState } from 'react';
import { Cancel, LikeOutlined } from '@vgno/icons';

import { Button } from '../../../components/Button/Button';
import { Box } from '../Box';
import { trackHelpButtonClick, trackHelpCenterLinkClick } from '../tracking';

import * as styles from './FeedbackButtons.module.scss';

const FeedbackGivenButton = ({ answer }: { answer: 'yes' | 'no' }) => {
  return (
    <Button isActiveBrandColor size="large">
      {answer === 'yes'
        ? 'Så flott, takk for din tilbakemelding!'
        : 'Beklager at vi ikke kunne hjelpe. Klikk på lenken nedenfor for hjelp.'}
    </Button>
  );
};

export const FeedbackButtons = () => {
  const [answer, setAnswer] = useState<'yes' | 'no' | null>(null);

  let buttons;

  const handleFeedback = useCallback((answer: 'yes' | 'no') => {
    trackHelpButtonClick(answer);
    setAnswer(answer);
    setTimeout(() => {
      setAnswer(null);
    }, 7000);
  }, []);

  if (answer === null) {
    buttons = (
      <>
        <Button
          onClick={() => handleFeedback('yes')}
          rounded
          isActiveBrandColor
          size="large"
        >
          <LikeOutlined />
          Ja, jeg fikk hjelp
        </Button>
        <Button
          onClick={() => handleFeedback('no')}
          rounded
          isActiveBrandColor
          size="large"
        >
          <Cancel />
          Nei, fikk ikke svar
        </Button>
      </>
    );
  } else {
    buttons = <FeedbackGivenButton answer={answer} />;
  }

  return (
    <Box>
      <div className={styles.container}>{buttons}</div>
      <p>Fant du ikke det du lette etter?</p>
      <a
        href={'https://support.vg.no/s/'}
        target="_blank"
        rel="noreferrer nofollow"
        onClick={trackHelpCenterLinkClick}
      >
        <Button variant="outlined" rounded size="large">
          Kontakt oss
        </Button>
      </a>
    </Box>
  );
};
